/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type birthdays_ParentBirthdayChild = {
    child_id: string;
    firstname: string;
    /**
     * The child's current group, else the next one; empty when it has none.
     */
    group_name: string;
    lastname: string;
    /**
     * PARENT, GUARDIAN, STEP_PARENT or FOSTER_PARENT.
     */
    relationship_type: birthdays_ParentBirthdayChild.relationship_type;
};
export namespace birthdays_ParentBirthdayChild {
    /**
     * PARENT, GUARDIAN, STEP_PARENT or FOSTER_PARENT.
     */
    export enum relationship_type {
        PARENT = 'PARENT',
        GUARDIAN = 'GUARDIAN',
        STEP_PARENT = 'STEP_PARENT',
        FOSTER_PARENT = 'FOSTER_PARENT',
    }
}

